// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wMRJ2bNBjrn1Ib {
  margin: var(--ds-space-0, 0);
  padding-bottom: var(--ds-space-050, 4px);
  padding-left: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 18px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `wMRJ2bNBjrn1Ib`
};
export default ___CSS_LOADER_EXPORT___;
